// extracted by mini-css-extract-plugin
module.exports = {"header-menu":"header-menu-194OW"};